import React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white' | 'gray';
  className?: string;
  inline?: boolean;
  centered?: boolean;
  ariaLabel?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'primary',
  className = '',
  inline = false,
  centered = false,
  ariaLabel = 'Loading...'
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-4 h-4';
      case 'md':
        return 'w-6 h-6';
      case 'lg':
        return 'w-8 h-8';
    }
  };

  const getColorClasses = () => {
    switch (color) {
      case 'primary':
        return 'text-primary-600';
      case 'white':
        return 'text-white';
      case 'gray':
        return 'text-gray-600';
    }
  };

  const spinner = (
    <div 
      role="status" 
      aria-label={ariaLabel}
      className={`${inline ? 'inline-flex' : 'flex'} items-center justify-center ${className}`}
    >
      <svg 
        className={`animate-spin ${getSizeClasses()} ${getColorClasses()}`} 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4" 
          fill="none" 
          opacity="0.25" 
        />
        <path 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" 
        />
      </svg>
    </div>
  );

  if (centered) {
    return (
      <div className="flex justify-center items-center">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default Spinner;